import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Loading } from "./components/Loading";
import { NotFound } from "./components/NotFound";
import ErrorBoundary from "./ErrorBoundary";

const Page1App = React.lazy(() => import("homepage/App"));
const EggsVault = React.lazy(() => import("eggsvault/App"));

function App() {
  useEffect(() => {
    window.holdstation = {
      PageNotFound: NotFound,
      Loading,
    };
    window.eggsvault = {
      PageNotFound: NotFound,
      Loading,
    };
  }, []);

  return (
    <BrowserRouter>
      <ErrorBoundary>
        <Routes>
          <Route path="/demo" element={<div>Host App - Home Page</div>} />
          <Route
            path="/*"
            element={
              <React.Suspense fallback={<Loading />}>
                <Page1App />
              </React.Suspense>
            }
          />
          <Route
            path="/eggsvault/*"
            element={
              <React.Suspense fallback={ <div className="h-screen flex items-center justify-center">
                
              </div>}>
                <EggsVault />
              </React.Suspense>
            }
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </ErrorBoundary>
    </BrowserRouter>
  );
}

export default App;
